import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import AppRoutes from "../../routes/AppRoutes";
import store from "../../reducers/store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";

import FullView from "../../views/FullView/fullview";
import BasicView from "../../views/BasicView/basicview";

const viewTable = {
    "/events/detection": "fullView",
    "/events/restriction": "fullView",
    "/overview": "fullView",
    "/policy": "fullView",
    "/policy/proxy": "fullView",
    "/policy/appcontrol": "fullView",
    "/policy/ignoreurl": "fullView",
    "/policy/blockurl": "fullView",
    "/policy/urlfilter": "fullView",
    "/policy/filescan": "fullView",
    "/visibility/saas": "fullView",
    "/visibility/traffic": "fullView",
    "/visibility/ext": "fullView",
    "/policy/ext": "fullView",
    "/policy/dlp": "fullView",
    "/policy/browser": "fullView",
    "/policy/awareness": "fullView",
    "/policy/browser_pr": "fullView",
    "/config/ldap": "fullView",
    "/config/siem": "fullView",
    "/config/sso": "fullView",
    "/license/users": "fullView",
    "/config/pac": "fullView",
    "/config/brand": "fullView",
    "/config/admins": "fullView",
    "/certificates": "fullView",
    "/license/installers": "fullView",
    "/logs/audit": "fullView",
    "/login": "basicView",
    "/ldap": "fullView",
    "/": "fullView",
};

class App extends Component {
  constructor() {
    super();
    this.state = {
      viewMode: (
        <FullView>
          <AppRoutes />
        </FullView>
      ),
    };
  }

  componentDidMount() {
    this.onRouteChanged();
  }

  render() {
    if (this.state.viewMode === "fullView") {
      return (
        <FullView>
          <AppRoutes />
        </FullView>
      );
    }

    return (
      <BasicView>
        <AppRoutes />
      </BasicView>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    window.scrollTo(0, 0);

    const view = viewTable[this.props.location.pathname];
    const isLogin = store.getState().auth.token;

    if (view) {
      this.setState({ viewMode: view });
    } else if (this.props.location.pathname === "/" && isLogin) {
      this.setState({ viewMode: "fullView" });
    } else {
      this.setState({ viewMode: "basicView" });
    }
  }
}

export default withRouter(App);
